<template lang="pug">
  .the-b2b-profile-parties
    b2b-filters-profile-parties(
      @filters-changed='filtersChanged',
      :i18n='$i18n',
      ref='profilePartiesFilter')
    ods-table(
      ref='tablaEmpresas',
      :data='parties.content',
      style='width: 100%',
      :default-sort='tableSort',
      @sort-change='sortHasChanged',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='mini',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='tradeName',
        :label='$t("profile.parties.entity_table.name")',
        :show-overflow-tooltip='true',
        sortable='true',
        :formatter='emptyValueFormatter')
      ods-table-column(
         width='140'
        prop='taxIdentificationNumber',
        :label='$t("profile.parties.entity_table.tax_identification_number")',
        :show-overflow-tooltip='true',
        sortable='true',
        :formatter='emptyValueFormatter')
      ods-table-column(
        width='120'
        prop='enable',
        align='center',
        :label='$t("profile.parties.entity_table.enabled")',
        :show-overflow-tooltip='true',
        :formatter='booleanFormatter')
      ods-table-column(
         width='120'
        prop='countryCodeAlfa3',
        :label='$t("profile.parties.entity_table.country")',
        :show-overflow-tooltip='true',
        sortable='true',
        :formatter='formatterCountry')
      ods-table-column(
         width='140'
        prop='province',
        :label='$t("profile.parties.entity_table.province")',
        :show-overflow-tooltip='true',
        sortable='true',
        :formatter='emptyValueFormatter')
      ods-table-column(
         width='160'
        prop='creationDateTime',
        :label='$t("profile.parties.entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        sortable='true',
        :formatter='formatterDate')
      ods-table-column(
        :label='$t("invoices.tooltip.detail")',
        align='center',
        width='120')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')

    ods-row.the-b2b-profile-parties__pagination()
      ods-col.the-b2b-profile-parties__pagination--left(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round,
            icon='ods-icon-download'
            style='display:inline;'
            :disabled='!parties || !parties.content || parties.content.length == 0',
            @click='downloadCsvButtonClicked')
            | CSV
      ods-col.the-b2b-profile-parties__pagination--right(:span='20')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='pageSizeChanged',
          @current-change='currentPageChanged',
          :current-page.sync='pagination.currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='pagination.pageSize',
          layout='total, sizes, prev, pager, next, slot',
          :total='pagination.totalElements')

    //- Empresas Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import B2bFiltersProfileParties from './B2bFiltersProfileParties'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-profile-parties',
  mixins: [Utils],
  data () {
    return {
      parties: {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'ASC',
          field: 'tradeName'
        },
        totalElements: 0,
        totalPages: 0
      },
      tableSort: {
        prop: 'tradeName',
        order: 'ascending'
      },
      pagination: {
        currentPage: 0,
        totalElements: 0,
        pageSize: 20
      },
      loading: false,
      params: {},
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: []
    }
  },
  computed: {
    ...mapGetters([
      'getActiveLang'
    ])
  },
  components: {
    B2bTableSelectRows,
    B2bFiltersProfileParties
  },
  methods: {
    ...mapActions([
      'getUserParties',
      'getUserPartiesCsv',
      'selectPartiesUser',
      'getProjectPartySponsorService'
    ]),

    // Conseguir datos de la fila en el hover del ratón
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    // Selección de Filas con el checkbox
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },
    /* Ir al detalle */
    async handleGoDetail (partyUser) {
      this.selectPartiesUser(partyUser)
      sessionStorage.setItem('partyName', this.currentRow.tradeName)

      router.push({
        name: 'profile-party',
        params: {
          partyId: partyUser.id,
          partyName: this.currentRow.tradeName
        }
      })
    },

    emptyValueFormatter (party, column) {
      if (
        party !== undefined &&
        party !== null &&
        party[column.property] !== undefined
      ) {
        return party[column.property]
      } else {
        return '-'
      }
    },

    formatterCountry (party, column) {
      if (party[column.property]) {
        return this.$t('countries.country_' + party.countryCodeAlfa3)
      }
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    booleanFormatter (party, column) {
      if (
        party !== undefined &&
        party !== null &&
        party[column.property] !== undefined
      ) {
        return party[column.property] ? this.$t('msg_generics.question.yes') : this.$t('msg_generics.question.no')
      } else {
        return '-'
      }
    },

    async doSearchUserParties (loadingText) {
      if (this.loading) {
        return false
      }
      this.loading = true
      const load = this.$loading({
        lock: true,
        text: loadingText
      })
      this.cleanResults()
      try {
        if (!this.params) {
          this.params = {}
        }
        this.params.size = this.pagination.pageSize
        this.params.page =
          this.pagination.currentPage > 0
            ? this.pagination.currentPage - 1
            : undefined
        this.params.sort = this.tableSort.prop
          ? this.tableSort.prop +
            ',' +
            (this.tableSort.order === 'ascending' ? 'ASC' : 'DESC')
          : undefined
        if (!this.params.sort) {
          this.params.sort = 'tradeName,ASC'
        }
        this.params.appFrom = 'B2bProfileParties'
        this.parties = await this.getUserParties(this.params)
        this.checkTableSort(this.parties.sort)
        this.checkTablePagination(
          this.parties.size,
          this.parties.number,
          this.parties.totalElements
        )
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.loading = false
      }
    },

    cleanResults () {
      this.parties = {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'ASC',
          field: 'tradeName'
        },
        totalElements: 0,
        totalPages: 0
      }
    },

    checkTableSort (sort) {
      if (
        sort == null ||
        sort.field === null ||
        sort.field === undefined
      ) {
        this.tableSort = {
          prop: null,
          order: null
        }
        this.$refs.tablaEmpresas.clearSort()
      } else {
        const sortAux = {
          prop: sort.field,
          order: sort.direction === 'ASC' ? 'ascending' : 'descending'
        }
        if (
          sortAux.prop !== this.tableSort.prop ||
          sortAux.order !== this.tableSort.order
        ) {
          this.tableSort = sortAux
          this.$refs.tablaEmpresas.clearSort()
          this.$refs.tablaEmpresas.sort(
            this.tableSort.prop,
            this.tableSort.order
          )
        }
      }
    },

    checkTablePagination (size, page, totalElements) {
      this.pagination = {
        currentPage: totalElements > 0 ? page + 1 : 0,
        totalElements: totalElements,
        pageSize: size
      }
    },

    async getNotificationErrorMessage (error) {
      const statusCode = error.status
      let errorSms = ''

      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },

    async sortHasChanged (sort) {
      if (this.loading) {
        return
      }
      if (
        this.tableSort.prop !== sort.prop ||
        this.tableSort.order !== sort.order
      ) {
        this.tableSort = {
          prop: sort.prop,
          order: sort.order
        }
        await this.doSearchUserParties(
          this.$t('msg_generics.order_table')
        )
      }
    },

    async pageSizeChanged (size) {
      if (this.loading) {
        return
      }
      this.pagination.pageSize = size
      await this.doSearchUserParties(this.$t('msg_generics.size_table'))
    },

    async currentPageChanged (page) {
      if (this.loading) {
        return
      }
      this.pagination.currentPage = page
      await this.doSearchUserParties(this.$t('msg_generics.pagination_table'))
    },

    async filtersChanged (params) {
      this.params = params
      if (this.loading) {
        return
      }
      await this.doSearchUserParties(this.$t('msg_generics.filter_selected'))
    },

    async doFirstSearch () {
      this.params = this.$refs.profilePartiesFilter.getQueryParams()
      this.pagination.currentPage = this.params.page ? this.params.page : this.pagination.currentPage
      this.pagination.pageSize = this.params.size ? this.params.size : this.pagination.pageSize
      await this.doSearchUserParties(this.$t('msg_generics.load_init'))
    },

    async downloadCsvButtonClicked (mouseEvent) {
      this.loading = true
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_csv')
      })
      try {
        if (!this.params) {
          this.params = {}
        }
        this.params.activeLang = this.getActiveLang
        console.log(this.params)
        const csvFile = await this.getUserPartiesCsv(this.params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: csvFile }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    }
  },
  async mounted () {
    await this.doFirstSearch()
  }
}
</script>

<style lang="scss" scoped>
.the-b2b-profile-parties {
  ::v-deep .ods-table {
    th {
      .cell {
        font-weight: 500;
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

 ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
         justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
